<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
    <div class="basis-1/2">
        <h1 class="pb-3 text-3xl font-semibold">{{ t('globalRatingPeriods.title') }}</h1>
    </div>
    <div class="mb-10">
        <drdp-add-global-rating-period [currentYear]="currentYear" [currentPeriods]="currentPeriods">
        </drdp-add-global-rating-period>
    </div>
    <div>
        <drdp-past-global-rating-periods [pastYears]="pastYears" [pastPeriods]="pastPeriods">
        </drdp-past-global-rating-periods>
    </div>
</div>
</ng-container>
